import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const ComparisonExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Comparison</h2>
      <p>We use comparative and superlative forms to compare people, places, and things, showing which one is more or less of a quality.</p>

      <h3><FaLightbulb /> Comparative and Superlative Forms</h3>
      <ul>
        <li>
          <strong>Short adjectives (1-2 syllables):</strong> add <strong>-er</strong> for the comparative and <strong>-est</strong> for the superlative.
          <br />
          <em>tall → taller → the tallest</em>
        </li>
        <li>
          <strong>Adjectives ending in <em>-e</em>:</strong> just add <strong>-r</strong> or <strong>-st</strong>.
          <br />
          <em>famous → more famous → the most famous</em>
        </li>
        <li>
          <strong>Longer adjectives (3+ syllables):</strong> use <strong>more</strong> and <strong>most</strong>.
          <br />
          <em>interesting → more interesting → the most interesting</em>
        </li>
      </ul>

      <h3><FaLightbulb /> Using <em>than</em> and <em>the</em></h3>
      <ul>
        <li>
          <strong>Comparatives</strong> compare two things and use <strong>than</strong>.
          <br />
          <em>Example: This book is <strong>more interesting than</strong> that one.</em>
        </li>
        <li>
          <strong>Superlatives</strong> compare three or more things and use <strong>the</strong>.
          <br />
          <em>Example: This is <strong>the most interesting</strong> book in the class.</em>
        </li>
      </ul>
    </div>
  );
};

export default ComparisonExplanation;
